import { createTheme } from '@mui/material';
import commonTheme from './common';

const themeMode = 'light';

const colors = {
  primary: {
    main: '#FFD700'
  },
  secondary: {
    main: '#1937E0'
  },
  background: {
    default: '#FFFFFF',
    paper: '#F8F8F8'
  },
  text: {
    primary: '#2C3E5D',
    secondary: '#44546F'
  }
};

const customColors = {
  app: {
    colors: {
      start: '#1CB0C8',
      center: '#8F88B9',
      end: '#FF3DA3'
    }
  },
  card: {
    background: {
      primary: '#B3B9C4',
      secondary: '#EEEEEE'
    }
  }
};

export const lightTheme = createTheme({
  ...commonTheme,
  custom: customColors,
  palette: {
    mode: themeMode,
    primary: {
      main: colors.primary.main
    },
    secondary: {
      main: colors.secondary.main
    },
    background: {
      default: colors.background.default,
      paper: colors.background.paper
    },
    text: {
      primary: colors.text.primary,
      secondary: colors.text.secondary
    },
    warning: {
      main: '#ed6c02'
    }
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          background: colors.background.paper
        }
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          background: colors.background.paper
        }
      }
    }
  }
});
